/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {VelocityComponent} from 'velocity-react';

import Profile from '../Profile';

import _get from 'lodash/get';

class EmbeddedProfile extends Component {
  constructor(props) {
    super (props);

    this.state = {
      isExtended: false,
      selectedAsset: null
    };
  }

  componentDidMount() {

    this.setState({
      selectedAsset: this.props.selectedAsset,
      isExtended: this.props.isExtended
    });
  }

  componentWillReceiveProps(newProps) {

    if (_get(this.props, 'selectedAsset.id') !== _get(newProps, 'selectedAsset.id')) {
      this.setState({
        selectedAsset: newProps.selectedAsset
      });
    }

    this.setState({
      isExtended: newProps.isExtended
    });
  }

  _onAnimationComplete() {

    if (!this.state.isExtended) {
      this.setState({selectedAsset: null});
    }
  }

  render() {

    let animationOnExpand = {
      marginTop: this.state.isExtended ? 0 : '-270px',
      marginBottom: this.state.isExtended ? '6px' : 0
    };

    return (
      <div className="profile-container" style={{marginBottom: 0}}>
        <VelocityComponent animation={animationOnExpand} complete={this._onAnimationComplete.bind(this)} duration={650}>
          <Profile entity={this.state.selectedAsset} onClose={this.props.onClose.bind(this)} />
        </VelocityComponent>
      </div>
    );
  }
}

EmbeddedProfile.propTypes = {
  selectedAsset: PropTypes.object,
  onClose: PropTypes.func
};

export default EmbeddedProfile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/EmbeddedProfile/embedded-profile.js